var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { EventAggregator } from "aurelia-event-aggregator";
import { ActivityLogIcon } from "../../../models/activity-logger/activity-log.models";
import { RequestClient } from "../../../services/basics/request-client.service";
import { bindable } from "aurelia-framework";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import * as Enumerable from "linq";
import { autoinject } from "aurelia-dependency-injection";
import { computedFrom } from "aurelia-binding";
import { Messages } from "../../../configuration/event-messages.constants";
import { Reflection } from "../../../utilities/reflection";
import { ArrayUtils } from "../../../utilities/arrays";
import { SignalClientService, SignalFunctions } from "../../../services/basics/signal-client.service";
import { ActivityLoggerComposer } from "./activity-logger-composer";
import { BindingEngine } from "aurelia-binding";
import { I18N } from 'aurelia-i18n';
var ActivityLogger = /** @class */ (function () {
    function ActivityLogger(requestClient, element, bindingEngine, activityLoggerResolver, signalService, notificationClientService, eventAggrigator, i18N) {
        var _this = this;
        this.requestClient = requestClient;
        this.element = element;
        this.bindingEngine = bindingEngine;
        this.activityLoggerResolver = activityLoggerResolver;
        this.signalService = signalService;
        this.notificationClientService = notificationClientService;
        this.eventAggrigator = eventAggrigator;
        this.i18N = i18N;
        this.subscriptions = [];
        this.logIcons = [];
        this.showLogIconsSelection = false;
        this.logs = [];
        this.filteredLogs = [];
        this._searchText = "";
        this.filterOpened = false;
        this.allFiltersSelected = true;
        this.options = {
            weekday: "long", year: "numeric", month: "short",
            day: "numeric", hour: "2-digit", minute: "2-digit"
        };
        this.newLog = {
            createdBy: 0, dateCreated: (new Date()).toJSON(), userName: null,
            activityLogId: 0, entityActivityLogs: [],
            icon: null, id: 0, logIconId: 0, message: null
        };
        this.readonly = false;
        this.sendMessage = this.i18N.tr('add-text');
        this.logTitle = this.i18N.tr('history-text');
        this.activityLogsUpdated = function (data) {
            data.created.filter(function (x) { return x.entityActivityLogs.some(function (y) { return y.entityId == _this.entityId && y.entityTypeId == _this.entityTypeId; }); }).forEach(function (logPair) {
                _this.pushLog(logPair);
            });
        };
        this.selectAllFilters = function () {
            _this.logIcons.forEach(function (logIcon) {
                _this.logIconsDictionary[logIcon.logIconId].checked = _this.allFiltersSelected;
            });
        };
        this.closeIconsTooltip = function () {
            _this.showLogIconsSelection = false;
            _this.filterOpened = false;
        };
        this.subscriptionToDocumentClickEvent = this.eventAggrigator.subscribe(Messages.documentClick, this.closeIconsTooltip);
    }
    Object.defineProperty(ActivityLogger.prototype, "searchText", {
        get: function () {
            return this._searchText;
        },
        set: function (value) {
            this._searchText = value;
            this.filterLogs();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityLogger.prototype, "noAllSpaces", {
        get: function () {
            if (!this.newLog || !this.newLog.message) {
                return false;
            }
            var res = this.newLog.message.replace(/ /g, "");
            return res.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityLogger.prototype, "newLogIcon", {
        get: function () {
            var _this = this;
            return this.newLog ? this.logIcons.filter(function (x) { return x.logIconId === _this.newLog.logIconId; })[0] : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityLogger.prototype, "viewModel", {
        get: function () {
            if (!this.newLogIcon || !this._resolvedInstance || this._resolvedInstance.icon != this.newLogIcon.tag) {
                this._resolvedInstance = this.newLogIcon ? this.activityLoggerResolver.get(this.newLogIcon.tag) : null;
            }
            return this._resolvedInstance ? this._resolvedInstance.viewModel : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityLogger.prototype, "model", {
        get: function () {
            if (!this.newLogIcon || !this._resolvedInstance || this._resolvedInstance.icon != this.newLogIcon.tag) {
                this._resolvedInstance = this.newLogIcon ? this.activityLoggerResolver.get(this.newLogIcon.tag) : null;
                this._model = this._resolvedInstance ? this._resolvedInstance.modelInitiator() : null;
            }
            return this._model;
        },
        enumerable: false,
        configurable: true
    });
    ActivityLogger.prototype.attached = function () {
        this.signalService.subscribe(SignalFunctions.activityLogsUpdated, this.activityLogsUpdated);
    };
    ActivityLogger.prototype.detached = function () {
        if (this.newLog) {
            this.newLog = null;
            if (this.subscriptionToDocumentClickEvent) {
                this.subscriptionToDocumentClickEvent.dispose();
            }
        }
        this.signalService.unsubscribe(SignalFunctions.activityLogsUpdated, this.activityLogsUpdated);
    };
    ActivityLogger.prototype.getTime = function (date) {
        var numToTwoDigits = function (num) {
            return "0".concat(num).slice(-2);
        };
        var dateConverted = new Date(date);
        return numToTwoDigits(dateConverted.getHours()) + ":" + numToTwoDigits(dateConverted.getMinutes());
    };
    ActivityLogger.prototype.getDate = function (date) {
        var options = { weekday: "long", year: "numeric", month: "long", day: "numeric" };
        var dateConverted = new Date(date);
        return dateConverted.toLocaleDateString("en-UK", options);
    };
    ActivityLogger.prototype.openLogIconsSelection = function (event) {
        this.showLogIconsSelection = !this.showLogIconsSelection;
        event.stopPropagation();
    };
    ActivityLogger.prototype.entityTypeIdChanged = function () {
        if (this.entityTypeId > 0 && this.entityId > 0) {
            this.reload();
        }
        else {
            this.logs = [];
            this.filteredLogs = [];
        }
    };
    ActivityLogger.prototype.entityIdChanged = function () {
        if (this.entityTypeId > 0 && this.entityTypeId > 0) {
            this.reload();
        }
        else {
            this.logs = [];
            this.filteredLogs = [];
        }
    };
    ActivityLogger.prototype.reload = function () {
        var _this = this;
        if (!this.newLog) {
            this.newLog = this.getNewLog();
        }
        var body = { entityTypeId: this.entityTypeId, entityId: this.entityId };
        this.requestClient.get("ActivityLogs/GetActivityLogs", body)
            .then(function (response) {
            _this.logs = Enumerable.from(response)
                .orderByDescending(function (x) { return new Date(x.dateCreated); })
                .toArray();
            _this.filterLogs();
            if (!_this.newLog) {
                _this.newLog = _this.getNewLog();
            }
            _this.newLog.entityActivityLogs = [];
            _this.newLog.entityActivityLogs.push({ entityId: _this.entityId, entityTypeId: _this.entityTypeId });
        }, function (e) { });
    };
    ActivityLogger.prototype.getNewLog = function () {
        return {
            createdBy: 0, dateCreated: (new Date()).toJSON(), userName: null,
            activityLogId: 0, entityActivityLogs: [],
            icon: null, id: 0, logIconId: 0, message: null
        };
    };
    ActivityLogger.prototype.bind = function () {
        var _this = this;
        this.loadIcons().then(function (x) {
            if (_this.entityTypeId > 0 && _this.entityTypeId > 0) {
                _this.reload();
            }
            else {
                _this.logs = [];
                _this.filteredLogs = [];
            }
        });
    };
    ActivityLogger.prototype.selectIcon = function (icon) {
        this.newLog.logIconId = icon.logIconId;
        this.showLogIconsSelection = false;
    };
    ActivityLogger.prototype.getIcon = function (logIconId) {
        return this.logIcons.filter(function (x) { return x.logIconId === logIconId; })[0];
    };
    ActivityLogger.prototype.addLog = function (newLog) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.requestClient.post("ActivityLogs/AddLog", {}, { activityLog: newLog, additionalData: _this.model })
                .then(function (response) {
                resolve(response);
            }, function (e) { reject(); });
        });
    };
    ActivityLogger.prototype.messageChanged = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.newLog.message) {
                var indexOfColumn = _this.newLog.message.indexOf(":");
                var shortcut_1 = _this.newLog.message.substr(0, indexOfColumn);
                if (shortcut_1.indexOf(" ") === -1) {
                    var icon = _this.logIcons.filter(function (x) { return x.shortcut === shortcut_1; })[0];
                    if (icon && _this.newLog) {
                        _this.newLog.logIconId = icon.logIconId;
                        _this.newLog.message = _this.newLog.message.substr(indexOfColumn + 1);
                    }
                }
            }
        });
    };
    ActivityLogger.prototype.send = function () {
        var _this = this;
        this.sending = true;
        return new Promise(function (resolve, reject) {
            _this.addLog(_this.newLog).then(function (log) {
                _this.pushLog(log);
                _this.newLog = {
                    activityLogId: 0, entityActivityLogs: [
                        { entityId: _this.entityId, entityTypeId: _this.entityTypeId }
                    ],
                    createdBy: 0, dateCreated: (new Date()).toJSON(), userName: null,
                    icon: null, id: 0, logIconId: _this.logIcons[0].logIconId, message: null
                };
                resolve();
                _this.sending = false;
            }).catch(function (exception) {
                _this.sending = false;
                reject();
            });
        });
    };
    ActivityLogger.prototype.toggleFilter = function (event) {
        this.filterOpened = !this.filterOpened;
        event.stopPropagation();
    };
    ActivityLogger.prototype.pushLog = function (log) {
        log.icon = this.logIcons.filter(function (x) { return x.logIconId == log.logIconId; })[0];
        var index = ArrayUtils.firstIndex(this.logs, function (x) { return x.activityLogId > log.activityLogId; });
        if (this.logs.every(function (x) { return x.activityLogId != log.activityLogId; })) {
            this.logs.splice(index + 1, 0, log);
            this.filterLogs();
            this.dispatchEvent('new-log-pushed', log);
            this.notificationClientService.show(this.i18N.tr('added-new-log-successfully-text'), "", NotificationType.Success);
        }
    };
    ActivityLogger.prototype.loadIcons = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.requestClient.get("ActivityLogs/GetLogIcons", null)
                .then(function (response) {
                _this.logIcons = Enumerable.from(response).toArray();
                _this.logIconsDictionary = {};
                if (_this.subscriptions) {
                    _this.subscriptions.forEach(function (x) { return x.dispose(); });
                    _this.subscriptions = [];
                }
                _this.logIcons.forEach(function (x) {
                    _this.logIconsDictionary[x.logIconId] = { icon: x, checked: true };
                    //logic to maintain consistent the state of allFiltersCheckbox
                    _this.subscriptions.push(_this.bindingEngine.propertyObserver(_this.logIconsDictionary[x.logIconId], 'checked').subscribe(function (x) {
                        if (_this.allFiltersSelected && !x && _this.logIcons.every(function (z) { return !_this.logIconsDictionary[z.logIconId].checked; })) {
                            _this.allFiltersSelected = false;
                        }
                        else if (!_this.allFiltersSelected && x && _this.logIcons.every(function (z) { return _this.logIconsDictionary[z.logIconId].checked; })) {
                            _this.allFiltersSelected = true;
                        }
                    }));
                });
                _this.logIcons = Enumerable.from(response).where(function (x) { return x.isSelectable; }).toArray();
                if (_this.logIcons[0] && _this.newLog) {
                    _this.newLog.logIconId = _this.logIcons[0].logIconId;
                }
                resolve();
            }, function (e) { reject(); });
        });
    };
    ActivityLogger.prototype.dispatchEvent = function (nameEvent, data) {
        if (this.element && nameEvent) {
            var customEvent = new CustomEvent(nameEvent, { bubbles: true, detail: data });
            this.element.dispatchEvent(customEvent);
        }
    };
    ActivityLogger.prototype.filterLogs = function () {
        var _this = this;
        this.filteredLogs = this.searchText ? this.logs.filter(function (x) {
            return x.message.indexOf(_this.searchText) > -1 ||
                _this.logIconsDictionary[x.logIconId].icon.tag.indexOf(_this.searchText) > -1 ||
                x.userName.indexOf(_this.searchText) > -1 ||
                _this.getDate(x.dateCreated).indexOf(_this.searchText) > -1;
        }) : this.logs;
    };
    __decorate([
        computedFrom('_searchText'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], ActivityLogger.prototype, "searchText", null);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], ActivityLogger.prototype, "entityId", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], ActivityLogger.prototype, "entityTypeId", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ActivityLogger.prototype, "readonly", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ActivityLogger.prototype, "sendMessage", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ActivityLogger.prototype, "logTitle", void 0);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.newLog.message; })),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ActivityLogger.prototype, "noAllSpaces", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.newLog.logIconId; })),
        __metadata("design:type", ActivityLogIcon),
        __metadata("design:paramtypes", [])
    ], ActivityLogger.prototype, "newLogIcon", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.newLog.logIconId; })),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ActivityLogger.prototype, "viewModel", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.newLog.logIconId; })),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ActivityLogger.prototype, "model", null);
    ActivityLogger = __decorate([
        autoinject,
        __metadata("design:paramtypes", [RequestClient,
            Element,
            BindingEngine,
            ActivityLoggerComposer,
            SignalClientService,
            NotificationClientService,
            EventAggregator,
            I18N])
    ], ActivityLogger);
    return ActivityLogger;
}());
export { ActivityLogger };
